import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { startCookieClearance } from './cookieClearance';

// Store the root instance globally
let widgetRoot = null;

// Widget initialization function
const FoodFactsVoiceWidget = {
  init: function(options = {}) {
    try {
      // Never mount on excluded pages (default: the donation page), or when disabled via config.
      var _cfg = window.FoodFactsVoiceAgent || {};
      var _ex = _cfg.excludePaths || ['/support'];
      var _p = (window.location.pathname || '').replace(/\/+$/, '') || '/';
      if (_cfg.disabled === true || _ex.some(function (x) { return String(x).replace(/\/+$/, '') === _p; })) {
        console.log('🔇 Food Facts Voice Widget disabled on this page');
        return { destroy: function () {} };
      }
      // Single-instance guard: never mount a second widget, no matter how many
      // times init runs (an old + new loader both embedded, a cache transition
      // across a deploy, or a double script include).
      if (window.__ffVoiceWidgetMounted || document.querySelector('.voice-agent-container')) {
        console.log('🟡 Food Facts Voice Widget already present — skipping duplicate init');
        return { destroy: function () {} };
      }
      window.__ffVoiceWidgetMounted = true;

      console.log('🎤 FoodFactsVoiceWidget.init() called');
      
      // Create container if it doesn't exist
      let container = document.getElementById('foodfacts-voice-widget-root');
      
      if (!container) {
        console.log('📍 Creating widget container...');
        container = document.createElement('div');
        container.id = 'foodfacts-voice-widget-root';
        container.style.cssText = 'position: fixed; bottom: 0; right: 0; z-index: 999999; width: 100%; height: 100%; pointer-events: none;';
        document.body.appendChild(container);
      }

      // Unmount previous instance if it exists
      if (widgetRoot) {
        console.log('🔄 Unmounting previous widget instance...');
        widgetRoot.unmount();
      }

      // Render the React app
      console.log('⚙️ Rendering React app...');
      widgetRoot = ReactDOM.createRoot(container);
      widgetRoot.render(
        <React.StrictMode>
          <App {...options} />
        </React.StrictMode>
      );

      console.log('✅ Food Facts Voice Widget initialized successfully');
      
      return {
        destroy: () => {
          if (widgetRoot) {
            widgetRoot.unmount();
            widgetRoot = null;
          }
          if (container && container.parentNode) {
            container.parentNode.removeChild(container);
          }
          window.__ffVoiceWidgetMounted = false;
        }
      };
    } catch (error) {
      console.error('❌ Error initializing Food Facts Voice Widget:', error);
      throw error;
    }
  }
};

// Auto-initialize if running standalone (for development)
if (document.getElementById('root') && !window.__ffVoiceWidgetMounted) {
  window.__ffVoiceWidgetMounted = true;
  console.log('🎤 Running in standalone mode (development)');
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Export for UMD build
export default FoodFactsVoiceWidget;

// Expose globally for script tag usage - CRITICAL FOR WIDGET LOADER
if (typeof window !== 'undefined') {
  console.log('🌍 Exposing FoodFactsVoiceWidget to global window object');
  window.FoodFactsVoiceWidget = window.FoodFactsVoiceWidget || {};
  window.FoodFactsVoiceWidget.init = FoodFactsVoiceWidget.init;
  console.log('✅ window.FoodFactsVoiceWidget.init is now available');

  // Keep the floating button from covering a host site's cookie-consent banner.
  startCookieClearance();
}
